"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Specialization = void 0;
const class_validator_1 = require("class-validator");
const mocks_1 = require("../../mocks");
const property_1 = require("../../decorators/property");
const restricted_1 = require("../../decorators/restricted");
const searchable_1 = require("../../decorators/searchable");
class Specialization extends mocks_1.Model {
}
exports.Specialization = Specialization;
__decorate([
    (0, searchable_1.Searchable)(),
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)(),
    (0, property_1.Property)(),
    __metadata("design:type", String)
], Specialization.prototype, "name", void 0);
__decorate([
    (0, restricted_1.Whitelist)(),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.IsString)({ each: true }),
    (0, property_1.Property)({ type: [mocks_1.ObjectId] }),
    __metadata("design:type", Array)
], Specialization.prototype, "parentSpecIds", void 0);
__decorate([
    (0, property_1.Virtual)({ localIdField: 'parentSpecIds', ref: 'Specialization', isArray: true }),
    __metadata("design:type", Array)
], Specialization.prototype, "parentSpecs", void 0);
